<div class="panel-main">
    <div class="panel-content">
        <div class="panel-header" (click)="onSwitch()">
            {{title}}
            <span class="system-main__icon"><i [@animationRotate]="sStatus" class="fa fa-angle-double-right"></i></span>
        </div>
    
        <div class="panel-text" [@animationShowHide]="sStatus">
            <ng-content></ng-content>
        </div>
    </div>
</div>